<template>
  <div>
    <div
      v-for="(options, attributeCode) in availableFilters"
      :key="attributeCode"
      class="row mb20"
    >
      <label class="col-xs-12 uppercase align-left weight-600 fs-medium-small">
        {{ getAttributeLabel(attributeCode) }}
      </label>
      <div class="row col-xs-12 radio-input-wrapper">
        <div
          v-for="option in options"
          :key="option.id"
          class="radio-input relative flexible mt5"
        >
          <input
            :value="option.label"
            :id="option.label + '-' + attributeCode"
            :name="'variant-' + attributeCode"
            :checked="isSelected(attributeCode, option)"
            :disabled="disabled"
            type="radio"
            @change="selectVariant(attributeCode, option)"
          />
          <label :for="option.label + '-' + attributeCode" class="radioStyled fs13">
            {{ option.label }}
          </label>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  getAvailableFiltersByProduct,
  getSelectedFiltersByProduct
} from '@vue-storefront/core/modules/catalog/helpers/filters'
import { mapGetters } from 'vuex'
import { filterChangedProduct } from '@vue-storefront/core/modules/catalog/events'

export default {
  name: 'VariantSelector',
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapGetters({
      getCurrentProduct: 'product/getCurrentProduct',
      getCurrentProductConfiguration: 'product/getCurrentProductConfiguration',
      attributesByCode: 'attribute/attributeListByCode'
    }),
    availableFilters () {
      return getAvailableFiltersByProduct(this.getCurrentProduct)
    },
    selectedFilters () {
      return getSelectedFiltersByProduct(
        this.getCurrentProduct,
        this.getCurrentProductConfiguration
      )
    }
  },
  methods: {
    getAttributeLabel (attributeCode) {
      const attr = this.attributesByCode[attributeCode]
      return attr ? attr.frontend_label : attributeCode
    },
    isSelected (attributeCode, option) {
      const selected = this.selectedFilters[attributeCode]
      return selected && selected.label === option.label
    },
    async selectVariant (attributeCode, option) {
      const selectedConfiguration = Object.assign(
        { attribute_code: option.type },
        option
      )
      await filterChangedProduct(
        selectedConfiguration,
        this.$store,
        this.$router
      )
      await this.$store.dispatch('stock/getQuantity')
      this.$emit('variant-changed', { attributeCode, option })
    }
  }
}
</script>

<style lang="scss" scoped>
.radio-input {
  flex-basis: 90px;
  label {
    padding: 10px 0px;
    text-align: center;
    border: 1px solid #DCDCDC;
    color: #646464;
    display: block;
    text-transform: uppercase;
    font-size: 13px;
    cursor: pointer;
  }
  input {
    display: none;
    position: absolute;
    top: 3px;
    left: 0;
    &:checked + label {
      box-shadow: 0px 0px 0px 2px #3e3e3e !important;
      color: black;
      background-color: #F5D2D2;
    }
    &:hover,
    &:focus {
      + label {
        box-shadow: 0px 0px 0px 1px #3e3e3e;
      }
    }
    &:disabled + label {
      opacity: 0.5;
      pointer-events: none;
    }
  }
}
.flexible {
  padding: 0 8px;
}
.size-guide {
  color: #676776;
  img, span {
    vertical-align: middle;
    display: inline-block;
  }
}
</style>
